import { render, staticRenderFns } from "./QuestionRepository.vue?vue&type=template&id=254e2f5d&scoped=true"
import script from "./QuestionRepository.vue?vue&type=script&lang=js"
export * from "./QuestionRepository.vue?vue&type=script&lang=js"
import style0 from "./QuestionRepository.vue?vue&type=style&index=0&id=254e2f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e2f5d",
  null
  
)

export default component.exports